import type { UserRole } from '@/lib/api-client';

/**
 * Role options for the onboarding profile step and the Settings role card.
 * The other onboarding answers (lesson depth + flow) come from the shared
 * `lesson-settings-options` module, since they're existing lesson settings.
 */

export interface RoleOption {
  value: UserRole;
  label: string;
  description: string;
}

export const ROLE_OPTIONS: RoleOption[] = [
  {
    value: 'student',
    label: 'Student',
    description: 'Learn topics, solve doubts, and prep for exams.',
  },
  {
    value: 'teacher',
    label: 'Teacher / Educator',
    description: 'Create lessons and content, and save prep time.',
  },
  {
    value: 'professional',
    label: 'Working Professional',
    description: 'Upskill and learn alongside your job.',
  },
  {
    value: 'self_learner',
    label: 'Self-learner',
    description: 'Explore new topics out of curiosity.',
  },
];
